var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4199 10.922C21.5989 10.843 21.7509 10.7133 21.8569 10.5488C21.9628 10.3843 22.0183 10.1924 22.0162 9.99673C22.0142 9.80108 21.9548 9.61031 21.8455 9.44807C21.7361 9.28584 21.5815 9.15925 21.4009 9.08399L12.8299 5.17999C12.5694 5.06114 12.2863 4.99963 11.9999 4.99963C11.7135 4.99963 11.4305 5.06114 11.1699 5.17999L2.59992 9.07999C2.42189 9.15796 2.27044 9.28613 2.16409 9.44881C2.05774 9.61149 2.0011 9.80163 2.0011 9.99599C2.0011 10.1903 2.05774 10.3805 2.16409 10.5432C2.27044 10.7059 2.42189 10.834 2.59992 10.912L11.1699 14.82C11.4305 14.9388 11.7135 15.0003 11.9999 15.0003C12.2863 15.0003 12.5694 14.9388 12.8299 14.82L21.4199 10.922Z",
    stroke: "#94CB85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10V16",
    stroke: "#94CB85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5V16C6 16.7956 6.63214 17.5587 7.75736 18.1213C8.88258 18.6839 10.4087 19 12 19C13.5913 19 15.1174 18.6839 16.2426 18.1213C17.3679 17.5587 18 16.7956 18 16V12.5",
    stroke: "#94CB85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/Icon (8).b7cb7ff5d428bdadc008653249503b05.svg";
export { ForwardRef as ReactComponent };